var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgPatternCallToAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 876,
    height: 584,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D0202",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D0202",
    stopOpacity: 0.498,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 876 0)",
    fill: "url(#a)",
    fillRule: "evenodd",
    opacity: 0.309
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 292)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(0 -1 -1 0 292 292)",
    cx: 146,
    cy: 146,
    r: 146
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 876 0)",
    cx: 438,
    cy: 146,
    r: 146
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(0 1 1 0 584 -584)",
    cx: 730,
    cy: 146,
    r: 146
  })), /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(0 -1 -1 0 292 292)",
    cx: 146,
    cy: 146,
    r: 146
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 876 0)",
    cx: 438,
    cy: 146,
    r: 146
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPatternCallToAction);
export default __webpack_public_path__ + "static/media/bg-pattern-call-to-action.92fe2a1bed633d621811af27fadff2bb.svg";
export { ForwardRef as ReactComponent };